<template>
  <b-col>
    <b-row>
      <b-col cols="4" class="mt-1">
        <table class="w-full leading-normal text-gray" style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale text-xs">
          <tr class="bg-gray-pale">
            <th class="px-2 py-1">#</th>
            <th class="px-2 py-1">Document</th>
            <th class="px-2 py-1 text-center">EDMS</th>
            <th class="px-2 py-1 text-center">Date</th>
            <th class="px-2 py-1 text-center">Action</th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td class="px-2 py-1" colspan="12">
                <b-form-input v-model="search" v-on:change="fetchBuildingSocietyRegisteredDocuments(brn)" placeholder="Search Document Name" class="form-text text-xs"></b-form-input>
                <div class="mx-auto">
                  <b-progress value="100" v-if="loading" variant="#007ac5" height="0.2rem" animated></b-progress>
                </div>
              </td>
            </tr>
            <tr style="border: solid 1px #dedede;" v-for="(document, idx) in documents"
                class="cursor-pointer text-gray"
                :key="idx">
              <td class="px-2 py-1">
                <span class="text-xs">
                  {{(currentPage - 1) * limit + idx + 1}}
                </span>
              </td>
              <td class="px-2 py-1 hover:underline hover:text-blue hover:font-bold">
                <span class="text-xs text-capitalize" @click="view(document)">
                  {{cleanEntityType(document.name.toLowerCase())}}
                </span>
              </td>
              <td class="px-2 py-1 text-center text-xs">
                <i v-if="document.edmsId" class="text-green fa fa-check-double"></i>
                <i v-else class="text-gray_title fa fa-check"></i>
              </td>
              <td class="px-2 py-1 text-xs text-center">
                <span>{{dateFormat(document.createdAt)}}</span>
              </td>
              <td class="px-2 py-1 text-xs text-center">
                <i
                  class="fa fa-envelope text-blue cursor-pointer"
                  title="Resend to client"
                  @click="resend(document, idx)"
                ></i>
                <b-spinner class="mx-1" small v-if="resendingDoc && selectedIdx === idx"></b-spinner>
              </td>
            </tr>
            <tr v-if="documents.length === 0">
              <td colspan="12" class="bg-inertgrey text-center py-1">
                <span class="text-xs">No results found</span>
              </td>
            </tr>
          </tbody>
        </table>
        <b-row class="mx-1" v-if="pagination.totalPages > 1">
          <b-col cols="2">
            <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
          </b-col>
          <b-col cols="2">
            <b-row>
              <b-col cols="12">
                <p class="paginate-details text-center">
                  <b-badge class="bg-blue text-white">
                    {{(currentPage)}}/{{pagination.totalPages}}
                  </b-badge>
                </p>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="2">
            <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
          </b-col>
          <b-col cols="2"></b-col>
          <b-col cols="4">
            <b-row>
              <b-col class="mx-auto">
                <p class="paginate-details text-center text-xs font-bold">
                  <span>{{((currentPage - 1) * limit)}}</span> -
                  <span v-if="limit > documents.length ">{{pagination.totalElements}}</span>
                  <span v-else>{{currentPage * limit}}</span>
                  of {{pagination.totalElements}}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="8" class="mt-1">
        <b-overlay :show="loadingDocument" rounded="sm">
          <b-row>
            <b-col>
              <EDMSDocument v-if="!loadingDocument" class="w-full border border-gray" ref="edmsFile" :file="getEDMSFile"/>
            </b-col>
          </b-row>
        </b-overlay>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import EDMSDocument from "@/views/home/services/registry/business/document/EDMSDocument";
import {mapActions, mapGetters} from "vuex";
import {api} from "@/app/services/api.service";

export default {
  name: "BuildingSocietyDocuments",
  components: {EDMSDocument},
  props:{
    brn: {
      type: String,
      default: ""
    }
  },
  data(){
    return{
      loading: false,
      loadingDocument: false,
      resendingDoc: false,
      selectedIdx: null,
      documents: [],
      currentPage:1,
      limit:10,
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      search:""
    }
  },
  mounted() {
    if (this.brn) {
      this.fetchBuildingSocietyRegisteredDocuments(this.brn);
    }
  },
  methods:{
    ...mapActions(["fetchSocietyEDMSFile"]),
    async fetchBuildingSocietyRegisteredDocuments(brn) {
      this.loading = true;
      try {
        const response = await api().get("building-societies/societies/registry/get-registered-documents/" + brn);
        this.documents = response.data.content;
        this.pagination = {
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements
        };
      } catch (error) {
        this.errorToast("Error", error.response?.data?.message || "Failed to fetch documents");
      } finally {
        this.loading = false;
      }
    },
    cleanEntityType(name){
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    view(document){
      if(document.edmsId){
        let data = {
          documentHandle: document.edmsId,
          overlay: ""
        }
        this.loadingDocument = true
        this.fetchSocietyEDMSFile(data)
      }else{
        this.errorToast("Document Error", "This document is not yet in EDMS")
      }
    },
    resend(document, idx){
      this.resendingDoc = true
      this.selectedIdx = idx
      // TODO: wire up a resend action for building society documents using document.name, document.documentCode, document.edmsId
      this.successToast("Info", "Resend request submitted")
      this.resendingDoc = false
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetchBuildingSocietyRegisteredDocuments(this.brn)
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetchBuildingSocietyRegisteredDocuments(this.brn)
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
  },
  computed:{
    ...mapGetters(["getEDMSFile", "getNetworkStatus", "getRegistryError"])
  },
  watch:{
    brn(newBrn) {
      if (newBrn) {
        this.fetchBuildingSocietyRegisteredDocuments(newBrn);
      }
    },
    getEDMSFile(){
      this.loadingDocument = false
    },
    getRegistryError(){
      this.loadingDocument = false
      this.errorToast("Error", "Failed to get document")
    },
    getNetworkStatus(){
      this.loadingDocument = false
      this.errorToast("Document Error", "Document loading times out")
    },
  }
}
</script>

<style scoped>
.button {
  @apply text-center rounded-sm bg-blue text-xs text-white border border-blue px-2 py-1;
  font-size: 14px;
}

.button:hover {
  @apply bg-blue-dark;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>